import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnalyticEvents } from '@app/enums';
import { AnalyticService } from '@app/services';
import { BaseForm } from '@forms/base.form';
import { Employee } from '@models/employee/employee.model';
import { Review } from '@models/performance/review.model';

@Component({
    selector: 'app-form-review-details',
    templateUrl: './review-details.template.html',
})
export class ReviewDetailsForm extends BaseForm {
    @Input() review: Review;
    @Input() performanceReviewImprovements: boolean = false;
    @Output() subjectChanged: EventEmitter<null> = new EventEmitter<null>();
    previousSubjectId;

    constructor(private analyticService: AnalyticService) {
        super();
    }
    onSubjectChange(employee: Employee): void {
        if (this.previousSubjectId !== this.review.subjectId) {
            // set relation, we are using both a relation and direct id here
            this.review.subject = employee;
            this.subjectChanged.emit();
        }
        this.previousSubjectId = this.review.subjectId;
    }

    ngOnDestroy() {
        this.subjectChanged.unsubscribe();
    }

    trackMakingResponsesVisibleToReviewee(): void {
        if (this.review.subjectCanViewResults) {
            this.analyticService.trackEvent(
                AnalyticEvents.PerformanceAllPathsToCreateReviewSelectMakeResponsesVisibleToEmployee
            );
        }
    }

    trackMakingResponsesVisibleToOthers(): void {
        if (this.review.participantsCanViewResults) {
            this.analyticService.trackEvent(
                AnalyticEvents.PerformanceAllPathsToCreateReviewSelectMakeResponsesVisibleToOtherReviewParticipants
            );
        }
    }
}
